/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_IC_73_67 as Componente_IC_73_67,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
} from "../../runtime/index.jsx";
export function Componente_BC_66_67(e, t) {
  return (
    <div
      key={t}
      className={`flex flex-col gap-3 rounded-2xl border border-(--border) p-4`}
      children={[
        <Componente_IC_73_67 ancho={`w-2/3`} alto={`h-4`} />,
        <Componente_IC_73_67 ancho={`w-1/2`} alto={`h-2.5`} />,
        <Componente_IC_73_67 ancho={`w-1/3`} alto={`h-2.5`} />,
      ]}
    />
  );
}
